export class Downloadproducts {
  abmr: product;
  cbmr: product;
  clonemanager: product;
  cmlite: product;
  cobmr: product;
  fsblocker: product;
  nbmr: product;
  pbmr: product;
  tbmr: product;
  va: product;
  rbmr: product;
  sysback: product;
}

export class product {
  latest: Latest;
  archive: Archive;
}

export class Latest {
  installs: Install[];
  isos: Iso[];
  documentation: Documentation[];
}

export class Archive {
  installs: any[];
  isos: any[];
  documentation: any[];
}

export interface Install {
  size: number;
  lastModified: any;
  product: string;
  latest: boolean;
  url: string;
  version: string;
  sha256: string;
  md5: string;
}

export interface Iso {
  size: number;
  lastModified: any;
  product: string;
  latest: boolean;
  url: string;
  version: string;
  sha256: string;
  md5: string;
}

export class Documentation {
  size: number;
  lastModified: any;
  product: string;
  latest: boolean;
  url: string;
  version: string;
  sha256: string;
  md5: string;
}
